<template> 
	 <div class="row card-body">
        <!-- <nav class="border-bottom position-relative d-flex justify-content-between">
			<v-tabs show-arrows>
				<v-tabs-slider></v-tabs-slider>
				<v-tab v-for="(item, index) in tabItems" v-bind:key="index" @click="nodeClicked(item.id)">
					{{ item.name }}
				</v-tab>    
			</v-tabs>
      	</nav> -->
        <div v-if="tab1">
            <!-- <v-btn @click="fetchTemplateData(1015)" color="green" class="white--text">Click Me !!!</v-btn> -->
            <!-- <div class="form-row">
                <div class="form-label">
                    <span >{{ $t("res_CheckBox_MultiApproval")}}<span style="color: red"> *</span></span>
                </div>
                <div class="form-component">
                    <v-checkbox  v-model="editTemplateTab.checkbox" solo class="pb-3"></v-checkbox>
                </div>
            </div> -->
            <v-row>
                <v-row class="col-md-6" v-if="enableMultipleApprovalTemplate">
                    <v-col class="col-md-5 mt-4 pt-4"><span>{{ $t("res_CheckBox_MultiApproval")}} *</span></v-col>
                    <v-col><v-checkbox v-model="editTemplateTab.checkbox" solo class=""></v-checkbox></v-col>
                </v-row>
                <v-col class="col-md-12">
                    <label>{{ $t("res_Label_SignatureUsers") }} *</label>
                    <Multiselect 
                        style="padding-top: 10px;" v-model="editTemplateTab.signatoryUsers" label="name" track-by="id" open-direction="bottom" 
                        :options="editTemplateTab.users" :searchable="true" :loading="loading" :internal-search="false" :placeholder="$t('res_Label_Select')"
                        :clear-on-select="false" :close-on-select="false" :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="true"
                        :multiple="true" @search-change="asyncFindUsers" @close="editTemplateTab.users = []">
                        <template slot="option" slot-scope="props">
                            <div style="height: 50px; width: 100%; display: flex">
                                <div class="" style="">
                                    <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                </div>
                                <div class="ad__box" v-if="props.option.isUser">
                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                </div>
                                <div class="ad__box" v-else>
                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                </div>
                            </div>
                        </template>
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>
                </v-col>
                <v-col class="col-md-12">
                    <label>{{ $t("res_Label_TemplateSignSendRulesTo") }} *</label>
                    <Multiselect 
                        v-model="editTemplateTab.sender" label="name" track-by="name" open-direction="bottom" :placeholder="$t('res_Label_Select')" 
                        :options="editTemplateTab.sender_items" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" 
                        :close-on-select="false" :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                        @search-change="asyncFindSender"  @close="editTemplateTab.sender_items = []">
                        <template slot="option" slot-scope="props">
                            <div style="height: 50px; width: 100%; display: flex">
                                <div class="" style="">
                                    <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                </div>
                                <div class="ad__box" v-if="props.option.isUser">
                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                </div>
                                <div class="ad__box" v-else>
                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                </div>
                            </div>
                        </template>
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>
                </v-col>
                <v-col class="col-md-12">
                    <label>{{ $t("res_Label_TemplateSignSendRulesCc") }}</label>
                    <Multiselect 
                        v-model="editTemplateTab.cc" label="name" track-by="name" open-direction="bottom" :options="editTemplateTab.cc_items" 
                        :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="false" 
                        :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="true"
                        @search-change="asyncFindCCs" @close="editTemplateTab.cc_items = []" :placeholder="$t('res_Label_Select')">
                        <template slot="option" slot-scope="props">
                            <div style="height: 50px; width: 100%; display: flex">
                                <div class="" style="">
                                    <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                </div>
                                <div class="ad__box" v-if="props.option.isUser">
                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                </div>
                                <div class="ad__box" v-else>
                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                </div>
                            </div>
                        </template>
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>
                </v-col>
                <v-col class="col-md-12">
                    <label>{{ $t("res_Label_SignatureWidth") }}</label>
                    <v-text-field v-model="editTemplateTab.width" label="" solo></v-text-field>
                </v-col>
                <v-col class="col-md-12">
                    <label>{{ $t("res_Label_SignatureHeight") }}</label>
                    <v-text-field v-model="editTemplateTab.height" label="" solo></v-text-field>
                </v-col>
            </v-row>
        </div>
        <!-- </v-tab> -->
        <div v-if="tab2">
            <!-- <div class="form-row"> -->
            <v-row class="mt-3">
                <v-col md="8">     
                </v-col>
                <v-col md="2">
                    <h3 class="font-weight-bold mx-6 text-secondary">{{ $t("res_CheckBoxTitle_ShowHide")}}</h3>
                </v-col>
                <v-col md="2">
                    <h3 class="font-weight-bold mx-4 text-secondary">{{ $t("res_CheckBoxTitle_EnableDisable")}}</h3>
                </v-col>
            </v-row> 
            <!-- </div> -->
            <v-row > 
                <v-col md="2">
                    <span>{{ $t("res_Label_Sender") }}</span>
                </v-col>
                <v-col md="6">
                    <Multiselect 
                        v-model="sender.txtSender" label="name" track-by="id" color="red" open-direction="bottom" :options="sender.sender_items" 
                        :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="true" :close-on-select="true" :options-limit="300"
                        :max-height="200" :show-no-results="false" :hide-selected="false" :multiple="false" 
                        @search-change="asyncFindSystemMetadataSender" @close="sender.sender_items = []">
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>     
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="sender.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="sender.enableDisable"></v-checkbox>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="2">
                    <span>{{ $t("res_Label_Recipeint")}}</span>
                </v-col>
                <v-col md="6">
                    <Multiselect
                        v-model="recipient.txtRecipient" label="name" track-by="id" open-direction="bottom" :options="recipient.recipient_items" 
                        :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="true" :close-on-select="true" :options-limit="300"
                        :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false" @search-change="asyncFindRecipient" 
                        @select="getRecipientDesignatedPersons" @close="recipient.recipient_items = []">
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="recipient.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="recipient.enableDisable"></v-checkbox>
                </v-col> 
            </v-row>
            <v-row>
                <v-col md="2">
                    <span>{{ $t("res_Label_DesignatedPerson")}}</span>
                </v-col>
                <v-col md="6">
                    <Multiselect 
                        v-model="designatedPerson.txtDesignatedPerson" label="name" track-by="id" open-direction="bottom" :options="recipient_designated_persons" 
                        :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="true" :close-on-select="true" :options-limit="300"
                        :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false" @close="recipient_designated_persons = []">
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="designatedPerson.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="designatedPerson.enableDisable"></v-checkbox>
                </v-col>        
            </v-row>
            <v-row> 
                <v-col md="2">
                    <span>{{ $t("res_Label_CC")}}</span>
                </v-col>
                <v-col md="6">
                    <Multiselect 
                        v-model="cc.txtCC" label="name" track-by="id" open-direction="bottom" :options="cc.cc_items" :searchable="true" 
                        :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="false" :options-limit="300"
                        :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="true" @search-change="asyncFindSystemMetadataCCs"
                        @close="cc.cc_items = []">
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="cc.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="cc.enableDisable"></v-checkbox>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="2">
                    <span>{{ $t("res_Label_AddressedTo")}}</span>
                </v-col>
                <v-col md="6">
                    <Multiselect
                        v-model="addressedTo.txtAddressedTo" label="name" track-by="id" open-direction="bottom" :options="cc.cc_items" 
                        :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="false" :options-limit="300"
                        :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false" 
                        @search-change="asyncFindSystemMetadataCCs" @close="cc.cc_items = []">
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="addressedTo.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="addressedTo.enableDisable"></v-checkbox>
                </v-col>
            </v-row>
            <v-row> 
                <v-col md="2">
                    <span>{{ $t("res_Label_Importance")}}</span>
                </v-col>
                <v-col md="6">
                    <Multiselect
                        v-model="importance.importance" label="text" track-by="id" open-direction="bottom" :options="importance.importance_items" 
                        :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="true" :close-on-select="true" :options-limit="300"
                        :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false" @close="importance.importance_items = []">
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="importance.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="importance.enableDisable"></v-checkbox>
                </v-col>
            </v-row>
            <v-row> 
                <v-col md="2">
                    <span>{{ $t("res_Label_Priority")}}</span>
                </v-col>
                <v-col md="6">
                    <Multiselect
                        v-model="priority.priority" label="name" track-by="id" open-direction="bottom" :options="priority.priority_items" 
                        :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                        :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                        @close="priority.priority_items = []">
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="priority.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="priority.enableDisable"></v-checkbox>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="2">
                    <span>{{ $t("res_Label_Privacy") }}</span>
                </v-col>
                <v-col md="6">
                    <Multiselect
                        v-model="privacy.privacy" label="name" track-by="id" open-direction="bottom" :options="privacy.privacy_items"
                        :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                        :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                        @close="privacy.privacy_items = []">
                        <template slot="noOptions" slot-scope="props">
                            {{$t("res_Msgs_EmptySearch")}}
                        </template>
                    </Multiselect>  
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="privacy.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="privacy.enableDisable"></v-checkbox>
                </v-col>
            </v-row>
            <v-divider color="black"></v-divider>
            <v-row>
                <v-col md="2">
                    <span>{{ $t("res_Label_DocumentDate") }}</span>
                </v-col>
                <v-col md="6">
                    <v-menu content-class="p-0" v-model="documentDate.document_date_menu" :close-on-content-click="false"  
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }" >
                            <v-text-field solo v-model="documentDate.date" label="" readonly v-bind="attrs" v-on="on" append-icon="mdi-calendar">
                                <template v-slot:append>
                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker v-model="documentDate.date" @input="documentDate.document_date_menu = false" ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="documentDate.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="documentDate.enableDisable"></v-checkbox>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="2">
                    <span>{{ $t("res_Label_Subject")}}</span>
                </v-col>
                <v-col md="6">
                    <v-text-field v-model="subject.subject" solo label=""></v-text-field>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="subject.showHide"></v-checkbox>  
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="subject.enableDisable"></v-checkbox>
                </v-col> 
            </v-row>
            <v-row>
                <v-col md="2">
                    <span>{{ $t("res_Label_TranslatedSubject")}}</span>
                </v-col>
                <v-col md="6">
                    <v-textarea v-model="translated.translatedSubject" solo></v-textarea>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="translated.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="translated.enableDisable"></v-checkbox>
                </v-col>
            </v-row>
            <v-row class="mb-5">
                <v-col md="2">
                    <span>{{ $t("res_Label_Keywords")}}</span>
                </v-col>
                <v-col md="6">
                    <v-textarea v-model="keyword.keywords" solo label=""></v-textarea>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="keyword.showHide"></v-checkbox>
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="keyword.enableDisable"></v-checkbox>
                </v-col>
            </v-row>
        </div>
        <v-row>
            <!-- <v-col md="12" align="center" class="mt-5" v-if="tab1">
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="nodeClicked(tab2)">Next</v-btn>
            </v-col> -->
            <v-col md="12" align="center" class="mt-5" v-if="tab2">
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="updatedtemplateData()">{{ $t("res_ButtonText_Update")}}</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import axios from 'axios'
    import constants from '@/assets/js/constants'
    import Multiselect  from 'vue-multiselect'
    import Tabs from './Tabs.vue'
	import * as utils from '@/assets/js/common.js'

	export default {
		name: 'EditTemplate',
        components: {Tabs, Multiselect},
        data: function () {
            return {
                tab1: true,
                tab2: false,
                selectedCheckbox: [],
                loading: false,
                recipient_designated_persons: [],

                editTemplateTab: {
                    checkbox: false,
                    sender: {},
                    cc: [{ id: 0, name: '' }],
                    sender_items: [],
                    cc_items: [],
                    selectedUser: {},
                    users: [],
                    signatoryUsers: [{ id: 0, name: '' }],
                    width: '',
                    height: ''
                },
                sender: {
                    showHide: '',
                    enableDisable: false,
                    txtSender: '',
                    sender_items: []
                },
                recipient: {
                    showHide: '',
                    enableDisable: false,
                    txtRecipient: '',
                    recipient_items: [],
                },
                designatedPerson: {
                    showHide: '',
                    enableDisable: false,
                    txtDesignatedPerson: {},
                },
                cc: {
                    showHide: '',
                    enableDisable: false,
                    txtCC: [{ id: 0, name: '' }],
                    cc_items: [],
                },
                addressedTo: {
                    showHide: '',
                    enableDisable: false,
                    txtAddressedTo: '',
                },
                importance: {
                    showHide: '',
                    enableDisable: false,
                    importance: {},
                    importance_items: [],
                },
                priority: {
                    showHide: '',
                    enableDisable: false,
                    priority: {},
                    priority_items: [],
                },
                privacy: {
                    showHide: '',
                    enableDisable: false,
                    privacy: {},
                    privacy_items: [],
                },
                documentDate: {
                    showHide: '',
                    enableDisable: false,
                    document_date_menu: false,
                    date: '',
                },
                subject: {
                    showHide: '',
                    enableDisable: false,
                    subject: '',
                },
                translated: {
                    showHide: '',
                    enableDisable: false,
                    translatedSubject: ''
                },
                keyword: {
                    showHide: '',
                    enableDisable: false,
                    keywords: ''
                },
                headers: [
                    {text: 'Action',         align: 'start',  value: 'event',  width: '', sortable: false},
                    {text: 'Signatory Name',                  value: 'name',  width:''}
                ],
                tabItems: [
                    { name: 'Edit Templates',  id: 'tab1' }, 
                    { name: 'System metadata', id: 'tab5'}
                ],
                enableMultipleApprovalTemplate : false
            };
        },

        props: {
            templateId: Number,
        },

        watch: {
            templateId: function (newVal, oldVal) {
                this.fetchTemplateData(newVal);
            }
        },

        mounted() 
        { 
            this.enableMultipleApprovalTemplate = enableMultipleApprovalTemplate;
            this.getAllMountData();
            this.getConstantsData()
            this.fetchTemplateData(this.templateId)
        },

        methods: 
        {
            getAllMountData()
            {
                this.asyncFindUsers("")
                this.asyncFindSender("")
                this.asyncFindCCs("")
                this.asyncFindSystemMetadataSender("")
                this.asyncFindRecipient("")
                this.asyncFindSystemMetadataCCs("")
            },
            nodeClicked(item)
            {
                if(item == "tab1")
                {
                    this.tab1 = true;
                    this.tab2 = false;
                }
                else
                {
                    this.tab1 = false;
                    this.tab2 = true;
                }
            },
            asyncFindUsers(query)
            {
                var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&search=';

                this.loading = true
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers})
                    .then(res => { this.editTemplateTab.users = res.data; this.loading = false; })
                    .catch(() => this.loading = false)
            },
            asyncFindSender(query)
            {
                var methodUrl = 'Template/GetCentralDispatcherOffices?isToControl=true&isCCControl=false';

                this.loading = true
                axios.get(constants.baseApiUrl + methodUrl , { headers: constants.headers})
                    .then(res => { 
                        this.editTemplateTab.sender_items = res.data;
                        this.loading = false; 
                    })
                    .catch(() => this.loading = false)
                
            },
            asyncFindCCs(query)
            {
                var methodUrl = 'Template/GetCentralDispatcherOffices?isToControl=false&isCCControl=true';

                this.loading = true
                axios.get(constants.baseApiUrl + methodUrl , { headers: constants.headers})
                    .then(res => { 
                        this.editTemplateTab.cc_items = res.data;
                        this.loading = false; 
                    })
                    .catch(() => this.loading = false)
            },
            asyncFindSystemMetadataSender(query)
            {
                var methodUrl = 'StructureUser/search?showUsers=false&showInternalStructures=true&showExternalStructures=true&search=';

                this.loading = true
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers})
                    .then(res => { this.sender.sender_items = res.data; this.loading = false; })
                    .catch(() => this.loading = false)
            },
            asyncFindRecipient(query)
            {
                var methodUrl = 'StructureUser/search?showUsers=false&showInternalStructures=true&showExternalStructures=true&search=';

                this.loading = true
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers})
                    .then(res => { this.recipient.recipient_items = res.data; this.loading = false; })
                    .catch(() => this.loading = false)
            },
            asyncFindSystemMetadataCCs(query)
            {
                var methodUrl = 'StructureUser/search?showUsers=false&showInternalStructures=true&showExternalStructures=false&search=';

                this.loading = true
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers})
                    .then(res => { this.cc.cc_items = res.data; this.loading = false; })
                    .catch(() => this.loading = false)
            },
            getConstantsData()
            {
                this.privacy.privacy_items = constants.privacies;
                this.priority.priority_items = constants.priorities;
            },
            getImportanceItems()
            {
                axios.get(constants.ctsApiUrl + 'Importance/ListImportances', {headers: constants.headers})
                    .then(response => { 
                        this.importance.importance_items = response.data; 
                        if (this.importance.importance_items.length > 0) 
                            this.importance.importance = this.importance.importance_items[0]
                        this.loading = false; 
                    })
                    .catch(error => this.loading = false)
            },
            getRecipientDesignatedPersons(item)
            {
                if (item != null && item != undefined && item.id != null && item.id != undefined) 
                {
                    axios.get(constants.baseApiUrl + 'Document/GetDesignatedPersons?structureIds=' + item.id, {headers: constants.headers})
                        .then(response => 
                        {
                            this.recipient_designated_persons = response.data
                            this.designatedPerson.txtDesignatedPerson = {}
                        })
                }
                else
                {
                    this.recipient_designated_persons = []
                }
            },
            fetchTemplateData(templateId)
            {
                axios.get(constants.baseApiUrl + 'Template/GetTemplateData?templateId=' + templateId, { headers: constants.headers })
                    .then((res) => 
                    {
                        this.editTemplateTab.width = res.data[0].width,
                        this.editTemplateTab.height = res.data[0].height
                        this.editTemplateTab.checkbox = res.data[0].isMultiApproval
                        var strSignSendRules = res.data[0].signSendRules != null ? res.data[0].signSendRules.toString() : ""
                        
                        if(strSignSendRules != "")
                        {
                            var splitSignSendRules = strSignSendRules.split("!!")
                            var splitSignSendRuleSender = splitSignSendRules[0]
                            var splitSignSendRuleCC = splitSignSendRules[1]

                            if(splitSignSendRuleSender.length > 0)
                            {
                                this.editTemplateTab.sender = []
                                var splitSignSendRuleSenderString = splitSignSendRuleSender.toString();  
                                    if(splitSignSendRuleSenderString.includes("#"))
                                    {
                                        var sender = splitSignSendRuleSenderString.split("#");
                                        this.editTemplateTab.sender = {name: sender[1]}
                                    }
                            }

                            if(splitSignSendRuleCC.length > 0)
                            {
                                this.editTemplateTab.cc = []
                                this.editTemplateTab.cc.push({ id: 0, name: '' })
                                var splitSignSendRuleCCString = splitSignSendRuleCC.toString(); 
                                var splitSignSendRuleCCArray = splitSignSendRuleCCString.split("|");
                                splitSignSendRuleCCArray.map( CC => 
                                {
                                    if(CC) 
                                    {
                                        var ccRule = CC.toString();  
                                        if(ccRule.includes("#"))
                                        {
                                            var ccRuleArray = ccRule.split("#");
                                            this.editTemplateTab.cc.push({name: ccRuleArray[1]})
                                        }
                                    }
                                })
                            }
                        }

                        this.editTemplateTab.signatoryUsers = [];
                        this.editTemplateTab.signatoryUsers.push({ id: 0, name: '' })
                        var strSignatureList = res.data[0].signatoryList != null ? res.data[0].signatoryList : "";

                        if(strSignatureList != "")
                        {
                            var splitSignatureList = strSignatureList.split("|")

                            splitSignatureList.map(sig => {
                                if(sig) 
                                {
                                    var strSignature = sig.toString();
                                    this.selectedCheckbox.push(strSignature + "|");

                                    var splitSignature = strSignature.split("#");
                                    var signature = {
                                        id: splitSignature[0],
                                        name: splitSignature[1]
                                    }
                                    this.editTemplateTab.signatoryUsers.push(signature);
                                }
                            });
                        }
                        var defaultMetaData=res.data[0].defaultMetaData
                        if(defaultMetaData!=null && defaultMetaData!=''){
                            ///TO DO - ADA
                        }

                        var lstTemplateControl = res.data[0].templateControlInfos.length > 0 ? res.data[0].templateControlInfos : "";

                        if(lstTemplateControl != "")
                        {
                            
                            lstTemplateControl.forEach( itemControl => 
                            {
                                if(itemControl.controlName === "Sender")
                                {
                                    this.sender.showHide = itemControl.isShowHide,
                                    this.sender.enableDisable = itemControl.isEnableDisable
                                    this.sender.txtSender = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName === "Recipient")
                                {
                                    this.recipient.showHide = itemControl.isShowHide,
                                    this.recipient.enableDisable = itemControl.isEnableDisable
                                    this.recipient.txtRecipient = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName.includes("Designated Person"))
                                {
                                    console.log("Designated")
                                    this.designatedPerson.showHide = itemControl.isShowHide,
                                    this.designatedPerson.enableDisable = itemControl.isEnableDisable
                                    this.designatedPerson.txtDesignatedPerson = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName.includes("CC"))
                                {
                                    this.cc.showHide = itemControl.isShowHide,
                                    this.cc.enableDisable = itemControl.isEnableDisable
                                    this.cc.txtCC = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName.includes("Addressed To"))
                                {
                                    this.addressedTo.showHide = itemControl.isShowHide,
                                    this.addressedTo.enableDisable = itemControl.isEnableDisable
                                    this.addressedTo.txtAddressedTo = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName.includes("Importance"))
                                {
                                    this.importance.showHide = itemControl.isShowHide,
                                    this.importance.enableDisable = itemControl.isEnableDisable
                                    this.importance.importance = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName.includes("Priority"))
                                {
                                    this.priority.showHide = itemControl.isShowHide,
                                    this.priority.enableDisable = itemControl.isEnableDisable
                                    this.priority.priority = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName.includes("Privacy"))
                                {
                                    this.privacy.showHide = itemControl.isShowHide,
                                    this.privacy.enableDisable = itemControl.isEnableDisable
                                    this.privacy.privacy = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName.includes("Document Date"))
                                {
                                    this.documentDate.showHide = itemControl.isShowHide,
                                    this.documentDate.enableDisable = itemControl.isEnableDisable
                                    this.documentDate.date = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName.includes("Subject"))
                                {
                                    this.subject.showHide = itemControl.isShowHide,
                                    this.subject.enableDisable = itemControl.isEnableDisable
                                    this.subject.subject = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName.includes("Translated Subject"))
                                {
                                    this.translated.showHide = itemControl.isShowHide,
                                    this.translated.enableDisable = itemControl.isEnableDisable
                                    this.translated.translatedSubject = JSON.parse(itemControl.defaultValue)
                                }
                                else if(itemControl.controlName.includes("Keywords"))
                                {
                                    this.keyword.showHide = itemControl.isShowHide,
                                    this.keyword.enableDisable = itemControl.isEnableDisable
                                    this.keyword.keywords = JSON.parse(itemControl.defaultValue)
                                }
                            });
                        }
                    })
                .catch(err => console.warn(err))
            },
            CapitalizeFirstLetter(str)
            {
				return utils.CapitalizeFirstLetter(str)
            },
            GetMultiSelectSubHeaderDisplay(options)
            {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            },
            updatedtemplateData()
            {
                var senderBody='';
                var ccBody = '';

                if (this.editTemplateTab.sender.name != undefined)
                {
                    senderBody = this.editTemplateTab.sender.name + "#" + this.editTemplateTab.sender.name + "!!"
                }
                if (this.editTemplateTab.cc.length > 0)
                {
                    this.editTemplateTab.cc.map(cc => { 
                        if (cc.name != "")
                        {
                            ccBody += cc.name + "#" + cc.name + "|"
                        }
                    });
                }

                //var templateControl = [];
                //this.cc.txtCC = this.cc.txtCC.filter(e => e.id !== 0);
                // templateControl.push(
                //     {ControlName: "Sender", isShowHide: this.sender.showHide == true ? true: false, 
                //         isEnableDisable: this.sender.enableDisable == true ? true: false, 
                //         DefaultValue: this.sender.txtSender === '' ? '': JSON.stringify(this.sender.txtSender)},
                //     {ControlName: "Recipient", isShowHide: this.recipient.showHide == true ? true: false, 
                //         isEnableDisable: this.recipient.enableDisable == true ? true: false, 
                //         DefaultValue: this.recipient.txtRecipient === '' ? '': JSON.stringify(this.recipient.txtRecipient)},
                //     {ControlName: "Designated Person", isShowHide: this.designatedPerson.showHide == true ? true: false, 
                //         isEnableDisable: this.designatedPerson.enableDisable == true ? true: false, 
                //         DefaultValue: this.designatedPerson.txtDesignatedPerson === '' ? '': JSON.stringify(this.designatedPerson.txtDesignatedPerson)},
                //     {ControlName: "CC", isShowHide: this.cc.showHide == true ? true: false, 
                //         isEnableDisable: this.cc.enableDisable == true ? true: false, 
                //         DefaultValue: this.cc.txtCC === '' ? '': JSON.stringify(this.cc.txtCC)},
                //     {ControlName: "Addressed To", isShowHide: this.addressedTo.showHide == true ? true: false, 
                //         isEnableDisable: this.addressedTo.enableDisable == true ? true: false, 
                //         DefaultValue: this.addressedTo.txtAddressedTo === '' ? '': JSON.stringify(this.addressedTo.txtAddressedTo)},
                //     {ControlName: "Importance", isShowHide: this.importance.showHide == true ? true: false, 
                //         isEnableDisable: this.importance.enableDisable == true ? true: false, 
                //         DefaultValue: this.importance.importance === '' ? '': JSON.stringify(this.importance.importance)},
                //     {ControlName: "Priority", isShowHide: this.priority.showHide == true ? true: false, 
                //         isEnableDisable: this.priority.enableDisable == true ? true: false, 
                //         DefaultValue: this.priority.priority === '' ? '': JSON.stringify(this.priority.priority)},
                //     {ControlName: "Privacy", isShowHide: this.privacy.showHide == true ? true: false, 
                //         isEnableDisable: this.privacy.enableDisable == true ? true: false, 
                //         DefaultValue: this.privacy.privacy === '' ? '': JSON.stringify(this.privacy.privacy)},
                //     {ControlName: "Document Date", isShowHide: this.documentDate.showHide == true ? true: false, 
                //         isEnableDisable: this.documentDate.enableDisable == true ? true: false, 
                //         DefaultValue: this.documentDate.date === '' ? '': JSON.stringify(this.documentDate.date)},
                //     {ControlName: "Subject", isShowHide: this.subject.showHide == true ? true: false, 
                //         isEnableDisable: this.subject.enableDisable == true ? true: false, 
                //         DefaultValue: this.subject.subject === '' ? '': JSON.stringify(this.subject.subject)},
                //     {ControlName: "Translated Subject", isShowHide: this.translated.showHide == true ? true: false, 
                //         isEnableDisable: this.translated.enableDisable == true ? true: false, 
                //         DefaultValue: this.translated.translatedSubject === '' ? '': JSON.stringify(this.translated.translatedSubject)},
                //     {ControlName: "Keywords", isShowHide: this.keyword.showHide == true ? true: false, 
                //         isEnableDisable: this.keyword.enableDisable == true ? true: false, 
                //         DefaultValue: this.keyword.keywords === '' ? '': JSON.stringify(this.keyword.keywords)}
                // )

                var signatures = ""
                this.editTemplateTab.signatoryUsers.map(signature => 
                {
                    if(signature.name != "")
                    {
                        var signString = signature.id + "#" + signature.name + "|"
                        signatures += signString;
                    }
                })

                var data = {
                    TemplateId: this.templateId,
                    SignatoryList: signatures,
                    SignSendRules: senderBody + ccBody,
                    Width: this.editTemplateTab.width,
                    Height: this.editTemplateTab.height,
                    isMultiApproval: this.editTemplateTab.checkbox
                    //TemplateControls: templateControl
                };

                if(!data.SignatoryList || !data.SignSendRules){
                    window.showAlert("res_Msgs_FillRequired", "warning");
                    return;
                }

                axios.post(constants.baseApiUrl + 'Template/UpdateTemplateData' , data , { headers: constants.headers })
                .then(res => 
                {
                    if(res.data)
                    {
                        window.showAlert('Templated data updated successfully', 'success');
                        this.$emit("closeAdvanceEditTemplateDialog");
                        this.fetchTemplateData(this.templateId);
                    }
                })
                .catch(err => console.warn(err))
            }
        },
	}
</script>


<style>
.form-row {
  display: flex;
  min-height: 66px;
  max-height: 66px;
}

.form-label {
  width: 25%;
  padding: 10px;
}

.form-component {
    margin-top: -10px !important;
    padding-bottom: 25px;
  width: 75%;
}
</style>